import React from 'react';
import { aboutPageData } from '@data-ts/pages/about';
import { SectionContainer, StyledHeroText, TextPairingWrapper } from './AboutUsHero.styles';

export const AboutUsHero = () => {
  const { heroSection } = aboutPageData;
  return (
    <SectionContainer id="about_us_hero_section" backgroundImage="about-us/hero.jpg">
      <TextPairingWrapper>
        <StyledHeroText variant="hed56" color="mono7" tagName="h1">
          {heroSection.title}
        </StyledHeroText>
      </TextPairingWrapper>
    </SectionContainer>
  );
};
